import React from "react";
import { Helmet } from "react-helmet";
import PoliticaPrivacidadeBanner from "../components/PoliticaPrivacidadeBanner/PoliticaPrivacidadeBanner";
import PortalPrivacidadeHeader from "../components/PortalPrivacidadeHeader/PortalPrivacidadeHeader";
import AtualizacoesPolitica from "../components/AtualizacoesPolitica/AtualizacoesPolitica";
import PersonalizarCookies from "../components/PersonalizarCookies/PersonalizarCookies";
import ExercaSeusDireitos from "../components/ExercaSeusDireitos/ExercaSeusDireitos";
import SeusDireitos from "../components/SeusDireitos/SeusDireitos";
import PoliticaCookies from "../components/PoliticaCookies/PoliticaCookies";
import PoliticaPrivacidade from "../components/PoliticaPrivacidade/PoliticaPrivacidade";
import ExercerSeusDireitosEParaOutrasPessoas from "../components/ExercerSeusDireitosEParaOutrasPessoas/ExercerSeusDireitosEParaOutrasPessoas";
import TransferenciaInternacional from "../components/TransferenciaInternacional/TransferenciaInternacional";

const PortalPrivacidade = () => {

  return (
    <>
      <Helmet>
        <title>Portal Privacidade | CAIXA Consórcio</title>
      </Helmet>
      <PortalPrivacidadeHeader />
      <PoliticaPrivacidadeBanner />
      <PoliticaPrivacidade />
      <PoliticaCookies />
      <PersonalizarCookies />
      <SeusDireitos />
      <ExercaSeusDireitos />
      <ExercerSeusDireitosEParaOutrasPessoas />
      <TransferenciaInternacional />
      <AtualizacoesPolitica />
    </>
  );
};

export default PortalPrivacidade;
